import styled, { css } from 'styled-components';
import { ThemeProps } from '@/styles/global';

interface Container {
  active: boolean;
}

export const Container = styled.a`
  display: flex;
  border-radius: 0.25rem;
  box-shadow: 0px 0px 4px rgba(89, 115, 114, 0.16);
  padding: 1.5rem;
  cursor: pointer;
  ${(props: Container & ThemeProps) =>
    props.active &&
    css`
      box-shadow: 0 0 0.25rem rgb(16 168 35 / 50%);
    `};
  &:not(last-child) {
    margin-bottom: 1rem;
  }
  &:hover {
    box-shadow: 0 0 0.25rem rgb(16 168 35 / 50%);
  }
  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const Logo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 3.5rem;
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 0.25rem;
  background: #e0f4ee;
  margin-right: 1rem;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.p`
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 1.75rem;
  color: ${(props: ThemeProps) => props.theme.blackColor};
  margin: 0 0 0.5rem 0;
  @media (max-width: 768px) {
    font-size: 1rem;
    margin: 0 0 0.125rem 0;
  }
`;

export const AmountTitle = styled.p`
  font-weight: 400;
  line-height: 1.5rem;
  margin: 0;
  color: ${(props: ThemeProps) => props.theme.darkGrayColor};
`;
